import { EditIcon } from '@approvalmax/ui';
import { Box, Button, Dropdown, Flex, Text, TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useDropdownFieldEditor } from './DropdownFieldEditor.hooks';
import { messages } from './DropdownFieldEditor.messages';
import { DropdownFieldEditorProps } from './DropdownFieldEditor.types';

export const DropdownFieldEditor = memo<DropdownFieldEditorProps>((props) => {
    const {
        value,
        onSubmit,
        textFieldLabel,
        textFieldPlaceholder,
        textButtonSubmit,
        textButtonActivator,
        textMaxLength,
    } = props;

    const { valueInternal, handleOpen, handleChange, handleSubmit } = useDropdownFieldEditor(value, onSubmit);

    return (
        <Dropdown
            width={342}
            closeOnClickInnerButton
            onOpen={handleOpen}
            activator={
                <Button size='xsmall' color='blue10' startIcon={<EditIcon />}>
                    {textButtonActivator || messages.buttonEdit}
                </Button>
            }
        >
            <Box spacing='16'>
                <Flex spacing='12' alignItems='end' data-qa='report-name-edit'>
                    <Flex grow={1} shrink={0} spacing='8' direction='column'>
                        <Text fontSize='small' font='label'>
                            {textFieldLabel}
                        </Text>

                        <TextField
                            focus
                            size='small'
                            placeholder={textFieldPlaceholder}
                            value={valueInternal}
                            onChange={handleChange}
                            maxLength={textMaxLength}
                        />
                    </Flex>

                    <Flex grow={0} shrink={0}>
                        <Button size='small' color='blue80' disabled={!valueInternal.trim()} onClick={handleSubmit}>
                            {textButtonSubmit || messages.buttonSave}
                        </Button>
                    </Flex>
                </Flex>
            </Box>
        </Dropdown>
    );
});

DropdownFieldEditor.displayName = 'DropdownFieldEditor';
